@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="flex items-center gap-3">
  <label class="file">
    <input type="file" (change)="uploadFile($event)" id="file" />
    <span class="file-custom"></span>
  </label>
</div>
